import React from 'react';
import { usePersistedReducer } from '../../utilities/usePersistentReducer';
import { FormDispatchContext, FormContext } from './context';
import { FormState, FormAction } from './types';

interface Props {
  reducer: React.Reducer<FormState, FormAction>;
  initialState: FormState;
  children: React.ReactChild | React.ReactChild[];
  storageKey: string;
}

export const FormStateProvider: React.FC<Props> = ({
  reducer,
  initialState,
  children,
  storageKey
}) => {
  const { state, dispatch } = usePersistedReducer(reducer, initialState, storageKey);
  return (
    <FormDispatchContext.Provider value={dispatch}>
      <FormContext.Provider value={state}>{children}</FormContext.Provider>
    </FormDispatchContext.Provider>
  );
};
